
export enum StationSelectionScope {
    ROUTING = 'ROUTING', STRUCTURE = 'STRUCTURE'
}

export class StationSelectionIdentity {
    scope =  StationSelectionScope.ROUTING;
}
